/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { JSX, useEffect, useState } from 'react';
import { FieldProps, useFormikContext } from 'formik';
import ExpandableRow from './ExpandableRow';

import { iFVSCheckboxAll, iObligation } from '../../../interfaces/interfaces';
import styles from './ExpandableTableAccessible.module.scss';

interface iProp extends FieldProps {
  obligations: iObligation[];
  inactiveRows: boolean;
  selectedRows: boolean;
  selectAllButtonAtBottom?: boolean;
}
const ExpandableTableAccessible = ({ field, obligations, inactiveRows, selectedRows, selectAllButtonAtBottom = false }: iProp): JSX.Element => {
  const { name, value } = field;
  const formikContext = useFormikContext();
  const SelectedObligationsStep5 = value;
  const [selectedAll, setSelectedAll] = useState(!!selectedRows);
  const checkboxAllInit = new Array<iFVSCheckboxAll>();
  if (selectedRows) {
    obligations.forEach((v) => {
      checkboxAllInit.push({ number: v.Number, checked: true });
    });
  } else {
    obligations.forEach((v) => {
      checkboxAllInit.push({ number: v.Number, checked: false });
    });
  }
  const checkboxAllTrue = new Array<iFVSCheckboxAll>();
  const checkboxAllFalse = new Array<iFVSCheckboxAll>();
  checkboxAllInit.forEach((v) => {
    checkboxAllTrue.push({ number: v.number, checked: true });
    checkboxAllFalse.push({ number: v.number, checked: false });
  });
  const [allCheckedOrNot, setCheckedAll] = useState(SelectedObligationsStep5 || checkboxAllFalse);
  const [isAllChecked, setAllChecked] = useState(checkboxAllTrue === SelectedObligationsStep5);
  const handleCheckedAll = (isChecked: boolean) => {
    if (isChecked) {
      setCheckedAll(checkboxAllTrue);
    } else {
      setCheckedAll(checkboxAllFalse);
    }
  };
  useEffect(() => {
    if (!inactiveRows) {
      if (allCheckedOrNot?.length !== 0) {
        formikContext.setFieldValue(name, allCheckedOrNot);
        const checkedObs = allCheckedOrNot.reduce((accumulate: string, val: { checked: any; number: any; }) => {
          const checkedOb = accumulate + (val.checked ? `${val.number}, ` : '');
          return checkedOb;
        }, '').slice(0, -2);
        if (checkedObs && (allCheckedOrNot.length === checkedObs.split(',').length)) {
          setSelectedAll(true);
        } else {
          setSelectedAll(false);
        }
        if (checkedObs) {
          formikContext.setFieldValue('SelectedObNums', checkedObs);
        }
      }
    }
  }, [allCheckedOrNot, SelectedObligationsStep5]);

  return (
    <div className={styles.offenceDetails}>
      {!inactiveRows && selectAllButtonAtBottom
        && (
        <div className={styles.detailValues}>
          <div className={styles.checkBoxContainer}>
            <label className={styles.inputContainer}>
              <input
                type="checkbox"
                id="checkAll"
                checked={selectedAll}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    setAllChecked(!isAllChecked);
                    handleCheckedAll(isAllChecked);
                  }
                }}
                onChange={(e) => handleCheckedAll(e.target.checked)} />
              <span className={styles.inputBody}>Select all / De-select all</span>
              <span className={styles.tickContainer} />
            </label>
          </div>
        </div>
        )}
      <div className={styles.detailHeadings}>
        <span>Obligation #</span>
        <span>Offence Date</span>
        <span>Offence Description</span>
        <span>Amount</span>
        <span> </span>
      </div>
      {(!inactiveRows && selectedRows)
      && obligations.map((v) => (<ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} disabledCheckbox={false} selectedRows />
        ))}
      {(!inactiveRows && !selectedRows)
      && obligations.map((v) => (<ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} disabledCheckbox={false} selectedRows={false} />
        ))}
      {(inactiveRows && !selectedRows)
      && obligations.map((v) => (<ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} disabledCheckbox selectedRows={false} />
        ))}
      {(inactiveRows && selectedRows)
      && obligations.map((v) => (<ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} disabledCheckbox selectedRows />
        ))}
      {!inactiveRows && !selectAllButtonAtBottom
      && (
      <div className={styles.detailValues}>
        <div className={styles.checkBoxContainer}>
          <label className={styles.inputContainer}>
            <input
              type="checkbox"
              id="checkAll"
              checked={selectedAll}
              onKeyDown={(e) => {
                if (e.key === ' ') {
                  setAllChecked(!isAllChecked);
                  handleCheckedAll(isAllChecked);
                }
              }}
              onChange={(e) => handleCheckedAll(e.target.checked)} />
            <span className={styles.inputBody}>Select all / De-select all</span>
            <span className={styles.tickContainer} />
          </label>
        </div>
      </div>
      )}
    </div>
  );
};

export default ExpandableTableAccessible;
